import { Car, plateSize, plateType } from '@/commonTypes';
import styles from '../../styles.module.css';
import PlateBadge from '@/components/pages/home/HomeContent/CarSwitcher/PlateBadge';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';
import MainIcons from '@/icons/main';
import { ReactNode } from 'react';
import ToggleButton from './ToggleButton';
import PlateInput from '@/components/pages/home/HomeContent/HomeHero/PlateLookup/PlateInput';
import { TransformPlateNumber } from '@/functions/TransformPlateNumber';
type PlateHeaderProps = {
  plate: Car;
  open: boolean;
  aside?: ReactNode;
  priceText?: string;
  plateSize?: plateSize;
  plateType?: plateType;
};

export default function PlateCardHeader({
  plate,
  open,
  aside,
  priceText = 'مبلغ کل بدهی:',
  plateSize = 'sm',
  plateType = 'large',
}: PlateHeaderProps) {
  console.log('plate======', TransformPlateNumber(plate?.plate_char));
  let thisPlate = TransformPlateNumber(plate?.plate_char);
  return (
    <>
      <PlateBadge
        car={{ plate: { ...thisPlate, c: thisPlate?.a, a: thisPlate?.c } }}
        type={plateType}
        size={plateSize}
      />

      <div className={styles.plateInfo}>
        <div className={styles.plateName}>{plate?.name}</div>

        <div className={styles.plateDebt}>
          {priceText}
          <PriceSection value={plate?.inquire_price} className={styles.deptValue} />
        </div>
      </div>
    </>
  );
}
